<template>
  <el-card>
    <template slot="header">
      所有数据表
    </template>
    <el-table :data="tableList">
      <el-table-column prop="Tables_in_cxedu_lc_com" lable="名称"></el-table-column>
      <el-table-column lable="操作">
        <template slot-scope="scope">
          <el-button type="success" @click="showTable(scope.row)">生成</el-button>
          <el-button type="danger">闭包表</el-button>
        </template>
      </el-table-column>
    </el-table>
  </el-card>
</template>

<script>
  import {mapState} from 'vuex'
  export default {
    name: "Table",
    computed: {
      ...mapState({
        tableList: state => state.table.tableList
      })
    },
    data(){
      return {

      }
    },
    created (){
      this.$store.dispatch('table/getTableList')
    },
    methods: {
      showTable (row){
          this.$router.push({name:'TableCard', params:{name: row.Tables_in_cxedu_lc_com}})
      }
    }

  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/code/table/Table.vue